export const CY_SEARCH_BAR = 'search-bar'
export const CY_HOMEPAGE_CLIPS = 'homepage-clips'
export const attributeName = 'tid'
